import { Component, ViewChild } from '@angular/core';
import { ToolbarSettings } from '@m4u-angular/base/classes/BaseClasses';
import { BasePageComponent } from '@m4u-angular/base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@m4u-angular/base/component/ServiceBag';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { 
    BaseEntitiesResponse, BaseEntity, BaseState, GenericListEntity, NotificationDispatch, NotificationDispatchListParams 
} from '@m4u-angular/base/entities/BaseEntities';
import { NotificationDispatchEndpoint } from '@m4u-angular/core/endpoints/notification-dispatch.endpoint';
import { NotificationEndpoint } from '@m4u-angular/core/endpoints/notification.endpoint';
import { 
    EnumCRUDActions, EnumNotificationDeliveryOptions, EnumNotificationStatuses, EnumSystemOptions 
} from '@m4u-angular/core/framework/sysenums.enum';
import { NotificationDispatchGridComponent } from '../notification-dispatch-grid/notification-dispatch-grid.component';

export class State extends BaseState {
    public FromDate: Date;
    public UntilDate: Date;
    public DeliveryMethod: EnumNotificationDeliveryOptions;
    public Statuses: EnumNotificationStatuses[] = [];
    public TemplateID: number;
    public Templates: any[];
    public RelevantNotificationDeliveryOptions: any[];
    public StatusesOptions: EnumNotificationStatuses[] = [];
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-notification-dispatch-list',
    templateUrl: './notification-dispatch-list.component.html',
    styleUrls: ['./notification-dispatch-list.component.scss']
})
export class NotificationDispatchListComponent extends BasePageComponent<BaseEntity, State> {
    @ViewChild('notificationDispatchGrid') public notificationDispatchGrid: NotificationDispatchGridComponent;
    
    constructor(A: ServiceBagService,
        private notificationEndpoint: NotificationEndpoint,
        private notificationDispatchEndpoint: NotificationDispatchEndpoint) {
        super(A, 'NotificationDispatchListComponent', BaseEntity, State);
    }

    protected override OnInitComponent() {
        this.LoadDataSource();
    }

    override OnInitDataSources() {
        this.Do(this.notificationEndpoint.GetNotificationsTemplates(), false, (response: BaseEntitiesResponse<GenericListEntity>) => {
            this.State.Templates = response.Entities;
        });

        this.LoadDeliveryOptions();
    }

    protected override OnExternalEntitySaved(ExternalEntity: BaseEntity, 
        ExternalEntityType: new () => BaseEntity, ExternalEntityAction: EnumCRUDActions) {

        if (ExternalEntityType === NotificationDispatch) {
            this.LoadDataSource();
        }
    }

    override OnGetToolbarSettings() {
        return {
            IsAllowFilter: true,
            IsAllowExport: false,
            GridExtender: () => this.notificationDispatchGrid?.G
        } as ToolbarSettings;
    }

    override OnApplyFilter() {
        this.LoadDataSource();
    }

    override OnClearFilter() {
        this.State.FromDate = this.State.UntilDate = this.State.TemplateID = undefined;
        this.State.Statuses = [];
        this.LoadDataSource();
    }

    LoadDataSource() {
        const params = new NotificationDispatchListParams();
        params.FromDate = this.State.FromDate;
        params.UntilDate = this.State.UntilDate;
        params.DeliveryMethod = this.State.DeliveryMethod;
        params.Statuses = this.State.Statuses;
        params.TemplateID = this.State.TemplateID;

        this.DataSources['NotificationDispatches'] = new DataSourceCustomAction((options: DataLoadOptions) => 
            this.notificationDispatchEndpoint.GetNotificationDispatchesReport(params, options));
    }

    private LoadDeliveryOptions() {
        this.State.RelevantNotificationDeliveryOptions = this.LIST('NotificationDispatchDeliveryOptions')
            .sort((a, b) => a.SortOrder > b.SortOrder ? 1 : -1)
            .filter(x => {
                switch (x.Value) {
                    case EnumNotificationDeliveryOptions.Email:
                        return this.SystemOptionFlag(EnumSystemOptions.IsSupportNotificationMethodEmail);
                    case EnumNotificationDeliveryOptions.SMS:
                        return this.SystemOptionFlag(EnumSystemOptions.IsSupportNotificationMethodSMS);
                    case EnumNotificationDeliveryOptions.WhatsApp:
                        return this.SystemOptionFlag(EnumSystemOptions.IsSupportNotificationMethodWhatsApp);
                    case EnumNotificationDeliveryOptions.PushMessage:
                        return true;
                    default:
                        return false;
                }
            });
    }
}